import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Loading from '../../components/Loading/InitialLoading';

import BotContext from '../../context/FlowContext';
import UserContext from '../../context/UserContext';

import styles from './Home.module.css';
import { WelcomePanel } from './WelcomePanel';
import { BotsPanel } from './BotsPanel';
import WelcomePanelWithoutBots from './WelcomePanelWithoutBots';

const Home = (props) => {
  const botContext = useContext(BotContext);
  const userContext = useContext(UserContext);
  const [isLoadingBots, setIsLoadingBots] = useState(true);

  useEffect(() => {
    setIsLoadingBots(true);
    const fetchBots = () => botContext.fetchBots(() => setIsLoadingBots(false));

    fetchBots().catch((error) => {
      if (error.response && error.response.status === 404) {
        userContext.createUser().then(
          (response) => { if (response.status === 201) fetchBots(); },
        );
      }
    });
  }, []);

  const handleClickBot = (botId) => {
    props.selectBot(botId);
  };

  if (isLoadingBots) return <Loading />;

  const thereIsBots = Object.values(botContext.bots).length > 0;

  return (
    <>
      <div className={styles.Home}>
        {thereIsBots
          ? <WelcomePanel name={userContext.user.name} />
          : <WelcomePanelWithoutBots name={userContext.user.name} />}
        <BotsPanel bots={botContext.bots} handleClickBot={handleClickBot} />
      </div>
    </>
  );
};

export default withRouter(Home);
